import { api as aboutDialogApi } from '../Dialogs/AboutDialog/aboutDialogActions';
import * as systemService from 'infrastructure/js/services/systemService';

export let jsxActions = {};

jsxActions.help = function () {
  return function (dispatch, getState) {
    let url = 'https://plataine.zendesk.com/';
    let win = window.open(url, '_blank');
    win.focus();
    return true;
  };
};

jsxActions.showUserGuide = function () {
  return function (dispatch, getState) {
    return api.showUserGuide()(dispatch, getState);
  };
};

jsxActions.showAboutTpo = function () {
  return function (dispatch, getState) {
    aboutDialogApi.show(dispatch, getState)();
  };
};

export let api = {};

api.showUserGuide = function () {
  return function (dispatch, getState) {
    systemService.getUserGuide().then((response) => {
        // Check for X-Documentation-URL header (set by server in Docusaurus mode)
        const documentationUrl = response.headers.get('X-Documentation-URL');

        if (documentationUrl) {
              console.log('Documentation site mode: Opening user guide at:', documentationUrl);

              // Backend has already set Documentation signed cookies in the response
              // Just navigate to the Documentation URL
              window.open(documentationUrl, '_blank');

              return { success: true };
        }

        // PDF mode - response.body contains ReadableStream, parse as blob
        response.blob().then((blobResponse) => {

        if (blobResponse.size === 0) {
             console.error('show user guide failed');
             return { success: false };
        }

        console.log('PDF mode: Opening user guide PDF');
        var myURL = window.URL || window.webkitURL;
        var file = new Blob([blobResponse], { type: 'application/pdf' });
        var fileURL = myURL.createObjectURL(file);
        window.open(fileURL, '_blank');
       });
    });
  };
};
